var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m20.608 16.675-3.484-3.484-2.68-1.107a7.52 7.52 0 0 0 1.368-4.334c0-4.17-3.392-7.563-7.562-7.563S.687 3.58.687 7.75s3.393 7.563 7.563 7.563a7.52 7.52 0 0 0 4.366-1.392l1.105 2.673 3.484 3.484a2.407 2.407 0 1 0 3.403-3.403ZM2.062 7.75A6.195 6.195 0 0 1 8.25 1.562a6.195 6.195 0 0 1 6.188 6.188 6.195 6.195 0 0 1-6.188 6.188A6.195 6.195 0 0 1 2.062 7.75Zm17.573 11.356a1.033 1.033 0 0 1-1.458 0l-3.29-3.29-1.027-2.485 2.485 1.026 3.29 3.29a1.033 1.033 0 0 1 0 1.459Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b614e39ecd1d2dd50c2a418f38e12718.svg";
export { ForwardRef as ReactComponent };